import contact from 'src/i18n/fr/validations/contact';
import creditcard from 'src/i18n/fr/validations/creditcard';
import login from 'src/i18n/fr/validations/login';
import invoice from 'src/i18n/fr/validations/invoice';
import organisation from 'src/i18n/fr/validations/organisation';
import fundraising from 'src/i18n/fr/validations/fundraising';
import ticket from 'src/i18n/fr/validations/ticket';
import notifications from 'src/i18n/fr/validations/notifications';

const validations = {
  contact,
  creditcard,
  fundraising,
  invoice,
  login,
  notifications,
  organisation,
  ticket,
};

export default validations;
